module.exports = __webpack_public_path__ + "media/stylesheets/slick/fonts/slick-b7c9e1e479de3b53f1e4e30ebac2403a.woff";